import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Typography,
  Badge,
} from "@altimateai/lego";
import type { EntityMatchStats } from "../../services/rbac";

interface DetailedBreakdownProps {
  byEntityAndMatch: EntityMatchStats[];
}

export const RulesDetailedBreakdown = ({ byEntityAndMatch }: DetailedBreakdownProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Detailed Breakdown</CardTitle>
        <CardDescription>Entity types and match types combination</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="al-border al-border-gray-200 al-rounded-lg al-overflow-hidden">
          <table className="al-w-full al-border-collapse">
            <thead className="al-bg-gray-50">
              <tr>
                <th className="al-px-4 al-py-3 al-text-left">
                  <Typography className="al-text-gray-700 al-uppercase al-font-medium">
                    Entity Type
                  </Typography>
                </th>
                <th className="al-px-4 al-py-3 al-text-left">
                  <Typography className="al-text-gray-700 al-uppercase al-font-medium">
                    Match Type
                  </Typography>
                </th>
                <th className="al-px-4 al-py-3 al-text-left">
                  <Typography className="al-text-gray-700 al-uppercase al-font-medium">
                    Rules
                  </Typography>
                </th>
              </tr>
            </thead>
            <tbody className="al-bg-white">
              {byEntityAndMatch.map((stat, index) => (
                <tr key={index} className="al-border-b al-border-gray-200">
                  <td className="al-px-4 al-py-4">
                    <Badge className="!al-bg-indigo-100 !al-text-indigo-700 al-border al-border-indigo-200">
                      {stat.entity_type}
                    </Badge>
                  </td>
                  <td className="al-px-4 al-py-4">
                    <Badge className="!al-bg-teal-100 !al-text-teal-700 al-border al-border-teal-200">
                      {stat.match_type}
                    </Badge>
                  </td>
                  <td className="al-px-4 al-py-4">
                    <Typography variant="section-heading">{stat.rule_count}</Typography>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
